import { ColDef } from 'ag-grid-community';
import { currencyFormatter } from 'src/util/grid/cellFormatter';

import { numberFormatter } from '../MssViewPivot/mssPivotColDefs';

// Column definitions for Royalties grid using API data structure
export const royaltiesGridColDefs: ColDef[] = [
    {
        field: 'month',
        headerName: 'Month',
        filter: 'agSetColumnFilter',
        flex: 1,
        minWidth: 100,
        sortable: true
    },
    {
        field: 'territory',
        headerName: 'Territory',
        flex: 1,
        minWidth: 100,
        sortable: true
    },
    {
        field: 'vendor',
        headerName: 'Vendor',
        flex: 2,
        minWidth: 200,
        sortable: true
    },
    {
        field: 'earningInUSD',
        headerName: 'Earning in USD',
        flex: 2,
        minWidth: 150,
        sortable: true,
        valueFormatter: currencyFormatter
    },
    {
        field: 'currency',
        headerName: 'Local Currency',
        flex: 1,
        minWidth: 100,
        sortable: true
    },
    {
        field: 'earning',
        headerName: 'Earning in Local Currency',
        flex: 2,
        minWidth: 150,
        sortable: true,
        valueFormatter: numberFormatter
    }
];
